import { useEffect, useState } from "react";
import { Alert, Button, Table } from "react-bootstrap";
import alertService from "../services/alert.service";
import Loader from "./Spinner.component";

function AlertPopup({ alert }) {
  const [days, setdays] = useState(10);
  const [tickerInfo, setTickerInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const res = await alertService.getTickerInfo(alert.ticker, days);
      setTickerInfo(res);
      setIsLoading(false);
    };

    fetchData();
  }, [alert.ticker]);

  const handleSubmit = async (ticker) => {
    setIsLoading(true);
    const res = await alertService.getTickerInfo(ticker, days);
    setTickerInfo(res);
    setIsLoading(false);
  };

  const countDuplicateTypes = () => {
    const typeCounts = {};
    tickerInfo.forEach((item) => {
      const type = item.type;
      if (typeCounts[type]) {
        typeCounts[type]++;
      } else {
        typeCounts[type] = 1;
      }
    });
    return typeCounts;
  };

  return (
    <div>
      <h3>Alert Ticker : {alert.ticker}</h3>
      <hr />
      <div className="config-alerts">
        <label className="form-label" htmlFor="date">
          Information about this ticker last :
        </label>
        <div className="input-group">
          <input
            disabled={isLoading}
            className="form-control "
            name="date"
            type="number"
            onChange={(e) => setdays(e.target.value)}
            value={days}
          />
          <span className="input-group-text" id="basic-addon2">
            days
          </span>
        </div>
        <Button onClick={() => handleSubmit(alert.ticker, days)}>Submit</Button>
      </div>
      {isLoading ? (
        <Loader />
      ) : tickerInfo.length === 0 ? (
        <Alert className="mt-4" variant="info">
          No Information Available
        </Alert>
      ) : (
        <>
          <div className="mt-3">
            <ul className=" d-flex justify-content-start gap-5 list-unstyled  ">
              <li>
                <span className="fw-bold">Appearence : </span>
                {tickerInfo.length} Times
              </li>
              <li>
                <span className="fw-bold">Types : </span>

                {Object.entries(countDuplicateTypes()).map(([type, count]) => (
                  <span className="px-2" key={type}>
                    {type} <span className="badge bg-secondary rounded-pill">{count}</span>
                  </span>
                ))}
              </li>
            </ul>
          </div>

          <div style={{ overflow: "auto", maxHeight: "50vh" }}>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Ticker</th>
                  <th>Type</th>
                  <th>Open</th>
                  <th>Close</th>
                  <th>Date</th>
                  <th>volume</th>
                  <th>notes</th>
                </tr>
              </thead>
              <tbody style={{ overflow: "scroll", maxHeight: "50px" }}>
                {tickerInfo.map((item) => (
                  <tr key={item._id}>
                    <td>{item.ticker}</td>
                    <td>{item.type}</td>
                    <td>{item.open}</td>
                    <td>{item.close}</td>
                    <td>{item.date.split("T")[0]}</td>
                    <td>{item.volume}</td>
                    <td>{item.notes}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}
    </div>
  );
}

export default AlertPopup;
